export default __webpack_public_path__ + "static/media/Gujarat_4.e68aa188.png";